import { Button, styled, ButtonProps } from "@mui/material";
import { BUTTON_COLORS } from "../../../../constants";

const StyledButton = styled(Button)(({ theme }) => ({
  height: 56,
  fontSize: 16,
  backgroundColor: BUTTON_COLORS.primary,
  [theme.breakpoints.down("lg")]: {
    height: 48,
  },
}));

export const SubmitButton = ({ ...restProps }: ButtonProps) => {
  return <StyledButton fullWidth variant="contained" {...restProps} />;
};
